import { Page } from '@app/components/page/Page';
import DevicesList from '@app/modules/streamer-box/screens/devices-list/DevicesList';
import { Device } from '@mi-front/core';
import { NullState, ViewError } from '@mi-front/ui';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';
import { apiClient } from '../../../../api';
import StreamerBoxIcon from '../../components/StreamerBoxIcon';

const devicesQueryKey = ['streamerBox', 'devices'] as const;

function NoDevices() {
  return (
    <NullState className="p-6">
      <FormattedMessage
        id="streamerBox.listScreen.noDevices"
        defaultMessage="No se encontraron dispositivos"
      />
    </NullState>
  );
}

/**
 * Devices list screen: Screen shell with header and list. List uses MRT built-in
 * skeletons while loading; errors and empty state are handled in the content.
 */
export function DevicesListPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'streamerBox.listScreen.title',
    defaultMessage: 'Dispositivos StreamerBox',
  });

  const devicesQuery = useQuery<readonly Device[]>({
    queryKey: devicesQueryKey,
    queryFn: () => apiClient.streamerBox.fetchDevices(),
  });

  const showEmpty = !devicesQuery.isLoading && (devicesQuery.data?.length ?? 0) === 0;

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<StreamerBoxIcon />} title={title} />
      <Page.Content>
        {devicesQuery.error ? (
          <ViewError error={devicesQuery.error as Error} />
        ) : showEmpty ? (
          <NoDevices />
        ) : (
          <DevicesList query={devicesQuery} />
        )}
      </Page.Content>
    </Page>
  );
}
